import { render, staticRenderFns } from "./NewsInfo.vue?vue&type=template&id=880c780a&scoped=true"
import script from "./NewsInfo.vue?vue&type=script&lang=js"
export * from "./NewsInfo.vue?vue&type=script&lang=js"
import style0 from "./NewsInfo.vue?vue&type=style&index=0&id=880c780a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880c780a",
  null
  
)

export default component.exports